export const ENTRY = 'claimaccount';
export const PATH_NAME = 'claim-account';
export const BASE_PATH = `/${PATH_NAME}(/:bookingId)`;
export const PAGE_NAME = 'claimaccount';
export const PAGE_TYPE = 'ClaimAccount';
export const ANALYTICS_NAME = 'ClaimAccount';
export const TITLE = 'Claim Account | Looks like you already have an account';
export const ROLLUP_BUCKET = 'Utility';
